import { ArrowUpRight, Bot, ShieldAlert, Activity, Headset } from "lucide-react";
import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";

const features = [
  { icon: Bot, title: "AI support chatbots", desc: "Resolve customer questions instantly with AI assistants trained on your business." },
  { icon: Activity, title: "Security operations monitoring", desc: "Continuous security operations monitoring across your logs, events, and alerts." },
  { icon: ShieldAlert, title: "Real-time threat alerts", desc: "Detect and surface suspicious activity the moment it happens." },
  { icon: Headset, title: "Launch in minutes", desc: "Stand up a branded support and monitoring desk without the overhead." },
];

export function SecureDeskSection() {
  return (
    <section id="securedesk" className="bg-black py-24 lg:py-36 border-t border-white/10" data-testid="securedesk-section">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid gap-12 lg:grid-cols-[1.1fr_0.9fr] lg:gap-20 items-start">
          <div className="grid gap-px bg-white/10 border border-white/10 sm:grid-cols-2 rounded-2xl overflow-hidden order-2 lg:order-1">
            {features.map((f, i) => (
              <Reveal key={f.title} delay={i * 0.06}>
                <div className="h-full bg-surface p-7 hover:bg-[#232326] transition-colors duration-500">
                  <f.icon size={20} className="text-paper mb-6" strokeWidth={1.4} />
                  <h3 className="font-display text-lg tracking-tight text-paper mb-2">{f.title}</h3>
                  <p className="text-sm text-fog leading-relaxed">{f.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal className="order-1 lg:order-2">
            <div className="inline-flex items-center gap-2 rounded-full border border-white/15 px-3 py-1 mb-6">
              <span className="text-xs uppercase tracking-widest text-paper">SecureDesk</span>
              <span className="text-[9px] uppercase tracking-widest bg-white/10 text-paper rounded-full px-1.5 py-0.5">Powered by AI</span>
            </div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tighter text-paper leading-[0.95] max-w-[14ch]">
              Support and security, always on.
            </h2>
            <p className="mt-6 text-sm text-fog leading-relaxed max-w-md">
              AI customer support chatbots and security operations monitoring for businesses.
              SecureDesk pairs always-on customer assistance with round-the-clock security
              operations — so your team stays responsive and protected.
            </p>
            <Link
              to="/products/securedesk"
              data-testid="securedesk-cta"
              className="mt-9 group inline-flex items-center gap-2 rounded-full bg-paper text-black text-sm font-medium pl-6 pr-5 py-3.5 hover:bg-white transition-colors"
            >
              Launch SecureDesk
              <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </Link>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
